export default {
  data() {
    return {
      list: [],
      listLoading: false,
      listQuery: {
        pageNum: 1,
        pageSize: 5
      },
      total: 0,
      statusAttr: 'status', // 状态属性字段名称
      selectGroup: [],
      sortColumn: [] // 允许排序的列
    }
  },
  computed: {
    btnDisabled() {
      return this.selectGroup.length <= 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 单行删除
    delRow(id, handle) {
      this.$confirm('确认删除该数据?', '删除', { type: 'warning' })
        .then(() => {
          handle && handle(id)
        })
        .catch(() => {})
    },
    // 多行删除
    delRows(handle) {
      const { selectGroup } = this
      if (selectGroup.length > 0) {
        this.$confirm(`确认删除这${selectGroup.length}条数据?`, '批量删除', {
          type: 'warning'
        })
          .then(() => {
            handle && handle(selectGroup)
          })
          .catch(() => {})
      } else {
        this.$message.info('请先选择需要删除的数据')
      }
    },
    // 确认操作
    handleConfirm(content, title, handle) {
      this.$confirm(content, title, { type: 'warning' })
        .then(() => {
          handle && handle(this.selectGroup)
        })
        .catch(() => {})
    },
    // 提交内容且确认操作
    handlePrompt(
      tip,
      params,
      handle,
      inputPattern,
      inputErrorMessage,
      inputPlaceholder
    ) {
      this.$prompt(tip, '提示', {
        inputPattern,
        inputErrorMessage,
        inputPlaceholder
      })
        .then(({ value }) => {
          handle && handle(params, value)
        })
        .catch(() => {})
    },
    // 筛选
    handleFilter() {
      this.pageParams.page_no = 1
      this.getList()
    },
    // 路由跳转
    linkTo(name, params = {}, query = {}) {
      this.$router.push({
        name,
        params,
        query
      })
    },
    // 多选处理
    handleSelectionChange(arr) {
      this.selectGroup = arr
    },
    // 点击排序表头
    handleHeaderClick(column) {
      const { property, multiOrder } = column
      if (!this.sortColumn.includes(property)) return
      if (!multiOrder) {
        column.multiOrder = 'descending'
      } else if (multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }
      this.handleSortChange({
        prop: property,
        order: multiOrder
      })
    },
    handleHeaderClass({ column }) {
      column.order = column.multiOrder
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/tableHandle.js